"use strict";
var measures = {
      length: require('./definitions/length')
    , area: require('./definitions/area')
    , mass: require('./definitions/mass')
    , volume: require('./definitions/volume')
    , each: require('./definitions/each')
    , temperature: require('./definitions/temperature')
    , time: require('./definitions/time')
    , digital: require('./definitions/digital')
    , partsPer: require('./definitions/partsPer')
    , speed: require('./definitions/speed')
    , pace: require('./definitions/pace')
    , pressure: require('./definitions/pressure')
    , current: require('./definitions/current')
    , voltage: require('./definitions/voltage')
    , power: require('./definitions/power')
    , reactivePower: require('./definitions/reactivePower')
    , apparentPower: require('./definitions/apparentPower')
    , energy: require('./definitions/energy')
    , reactiveEnergy: require('./definitions/reactiveEnergy')
    , volumeFlowRate: require('./definitions/volumeFlowRate')
    , illuminance: require('./definitions/illuminance')
    , frequency: require('./definitions/frequency')
    , angle : require('./definitions/angle')
    , charge : require('./definitions/charge')
    , force : require('./definitions/force')
    , acceleration : require('./definitions/acceleration')
    , numberScale : require('./definitions/numberScale')
    , co2Emissions : require('./definitions/co2Emissions')
    , cfc11Emissions : require('./definitions/cfc11Emissions')
}
  , Converter;
  
const whitelistMeasures =  {
  area: measures.area,
  length: measures.length,
  mass: measures.mass,
  volume: measures.volume,
  time: measures.time,
  energy: measures.energy,
  numberScale: measures.numberScale,
  co2Emissions: measures.co2Emissions,
};

Converter = function (numerator, denominator) {
  if(denominator)
    this.val = numerator / denominator;
  else
    this.val = numerator;
};

/**
* Lets the converter know the source unit abbreviation
*/
Converter.prototype.from = function (from) {
  if(this.destination)
    throw new Error('.from must be called before .to');

  this.origin = this.getUnit(from);

  if(!this.origin) {
    this.throwUnsupportedUnitError(from);
  }

  return this;
};

/**
* Converts the unit and returns the value
*/
Converter.prototype.to = function (to) {
  if(!this.origin)
    throw new Error('.to must be called after .from');

  this.destination = this.getUnit(to);

  var result
    , transform;

  if(!this.destination) {
    this.throwUnsupportedUnitError(to);
  }

  // Don't change the value if origin and destination are the same
  if (this.origin.abbr === this.destination.abbr) {
    return this.val;
  }

  // You can't go from liquid to mass, for example
  if(this.destination.measure != this.origin.measure) {
    throw new Error('Cannot convert incompatible measures of '
      + this.destination.measure + ' and ' + this.origin.measure);
  }

  /**
  * Convert from the source value to its anchor inside the system
  */
  result = this.val * this.origin.unit.to_anchor;

  /**
  * For some changes it's a simple shift (C to K)
  * So we'll add it when convering into the unit (later)
  * and subtract it when converting from the unit
  */
  if (this.origin.unit.anchor_shift) {
    result -= this.origin.unit.anchor_shift
  }

  /**
  * Convert from one system to another through the anchor ratio. Some conversions
  * aren't ratio based or require more than a simple shift. We can provide a custom
  * transform here to provide the direct result
  */
  if(this.origin.system != this.destination.system) {
    transform = measures[this.origin.measure]._anchors[this.origin.system].transform;
    if (typeof transform === 'function') {
      result = transform(result)
    }
    else {
      result *= measures[this.origin.measure]._anchors[this.origin.system].ratio;
    }
  }

  /**
  * This shift has to be done after the system conversion business
  */
  if (this.destination.unit.anchor_shift) {
    result += this.destination.unit.anchor_shift;
  }

  /**
  * Convert to another unit inside the destination system
  */
  return result / this.destination.unit.to_anchor;
};

/**
* Converts the unit to the best available unit.
*/
Converter.prototype.toBest = function(options) {
  if(!this.origin)
    throw new Error('.toBest must be called after .from');

  var options = Object.assign({
    exclude: [],
    cutOffNumber: 1,
  }, options)

  var best;
  /**
    Looks through every possibility for the 'best' available unit.
    i.e. Where the value has the fewest numbers before the decimal point,
    but is still higher than 1.
  */
  this.possibilities().forEach(function(possibility) {
    var unit = this.describe(possibility);
    var isIncluded = options.exclude.indexOf(possibility) === -1;

    if (isIncluded && unit.system === this.origin.system) {
      var result = this.to(possibility);
      if (!best || (result >= options.cutOffNumber && result < best.val)) {
        best = {
          val: result,
          unit: possibility,
          singular: unit.singular,
          plural: unit.plural
        };
      }
    }
  }.bind(this));

  return best;
}

/**
* Finds the unit
*/
Converter.prototype.getUnit = function (abbr) {
  var found;

  Object.keys(measures).find(measure => {
    if (found) {
      return true
    }
    Object.keys(measures[measure]).find(system => {
      if (system == '_anchors')
        return true;

      var units = measures[measure][system];
      return Object.keys(units).find(testAbbr => {
        if(testAbbr === abbr) {
          found = {
            abbr: abbr
            , measure: measure
            , system: system
            , unit: units[testAbbr]
          };
          return true;
        }
      });
    });
  });

  return found;
};

var describe = function(resp) {
  return {
    abbr: resp.abbr
  , measure: resp.measure
  , system: resp.system
  , singular: resp.unit.name.singular
  , plural: resp.unit.name.plural
  };
}

/**
* An alias for getUnit
*/
Converter.prototype.describe = function (abbr) {
  var resp = Converter.prototype.getUnit(abbr);
  var desc = null;

  try {
    desc = describe(resp);
  } catch(err) {
    this.throwUnsupportedUnitError(abbr);
  }

  return desc;
};

/**
* Detailed list of all supported units
*/
Converter.prototype.list = function (measure) {
  var list = [];

  Object.keys(measures).forEach(testMeasure => {
    if(measure && measure !== testMeasure)
      return;

    Object.keys(measures[testMeasure]).find(system => {
      if (system === '_anchors')
        return true;

      var units = measures[testMeasure][system];
      Object.keys(units).forEach(abbr => {
        list = list.concat(describe({
          abbr: abbr,
          measure: testMeasure
          , system: system
          , unit: units[abbr]
        }));
      });
    });
  });

  return list;
};

function getValidUnits() {
  var validUnits = [];

  Object.keys(measures).forEach(measure => {
    Object.keys(measures[measure]).find(system => {
      if (system === '_anchors')
        return true;

      validUnits = validUnits.concat(Object.keys(measures[measure][system]));
    })
  })
  return validUnits;
}

Converter.prototype.throwUnsupportedUnitError = function (what) {
  throw new Error('Unsupported unit ' + what + ', use one of: ' + getValidUnits().join(', '));
}

/**
* Returns the abbreviated measures that the value can be
* converted to.
*/
Converter.prototype.possibilities = function (measure) {
  var possibilities = [];
  if(!this.origin && !measure) {
    possibilities = getValidUnits()
  } else {
	  measure = measure || this.origin.measure;
    Object.keys(measures[measure]).find(system => {
      if (system === '_anchors')
        return true;

      possibilities = possibilities.concat(Object.keys(measures[measure][system]));
    })
  }

  return possibilities;
};

/**
* Returns the abbreviated measures that the value can be
* converted to.
*/
Converter.prototype.measures = function () {
  return Object.keys(measures);
};

const groupByUnitAndSortByConversion = (result) =>
  Object.values(
    result.reduce((acc, item) => {
      acc[item.unit] = acc[item.unit] || [];
      acc[item.unit].push(item);
      return acc;
    }, {}),
  ).flatMap((group) => group.sort((a, b) => (b.conversion === 1 ? 1 : 0) - (a.conversion === 1 ? 1 : 0)));

Converter.prototype.getAvailableUnits = function () {
  let result = [];
  Object.entries(whitelistMeasures).forEach(([unitCategory, unitDefinitions]) => {
    const anchors = unitDefinitions['_anchors'];
    Object.entries(unitDefinitions).forEach(([system, units]) => {
      if (system === '_anchors') return;
      Object.entries(units).forEach(([code, unitData]) => {
        result.push({
          unit: unitCategory,
          unitType: unitData.name.plural,
          code,
          conversion: system === 'metric' ? unitData.to_anchor : unitData.to_anchor * anchors.metric.ratio,
        });
      });
    });
  });
  return groupByUnitAndSortByConversion(result);
};

const convert = function (value) {
  return new Converter(value);
};


module.exports = convert;
